import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Star, Loader2 } from "lucide-react";

export function Stars({ value, onChange, size = "w-6 h-6", testid = "stars" }) {
  return (
    <div className="flex gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n)} data-testid={`${testid}-${n}`}
          className={onChange ? "transition-transform hover:scale-110" : "cursor-default"}>
          <Star className={`${size} ${n <= value ? "fill-amber-400 text-amber-400" : "text-muted-foreground/40"}`} />
        </button>
      ))}
    </div>
  );
}

export function RateTicket({ ticket, onRated }) {
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/support/tickets/${ticket.id}/rate`, { stars, comment });
      toast.success("شكراً لتقييمك!");
      onRated();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <div className="rounded-2xl border border-amber-400/40 bg-amber-50/60 p-4 space-y-3" data-testid="rate-ticket-card">
      <div className="font-semibold text-sm">كيف كانت تجربتك مع خدمة العملاء؟</div>
      <Stars value={stars} onChange={setStars} size="w-8 h-8" testid="rate-star" />
      <Textarea value={comment} onChange={(e) => setComment(e.target.value)} maxLength={500} rows={2}
        placeholder="تعليق (اختياري)" className="bg-card" data-testid="rate-comment-input" />
      <Button className="rounded-full" disabled={!stars || busy} onClick={submit} data-testid="rate-submit-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "إرسال التقييم"}
      </Button>
    </div>
  );
}

export function TicketRating({ ticket }) {
  if (!ticket.rating) return null;
  return (
    <div className="rounded-xl bg-muted/40 p-3 flex flex-wrap items-center gap-3 text-sm" data-testid="ticket-rating">
      <span className="text-muted-foreground">تقييم العميل:</span>
      <Stars value={ticket.rating} size="w-4 h-4" testid="ticket-rating-stars" />
      {ticket.rating_comment && <span className="text-muted-foreground" data-testid="ticket-rating-comment">«{ticket.rating_comment}»</span>}
    </div>
  );
}
